// Notification
export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';

// Career
export const REQUEST_CAREER = 'REQUEST_CAREER';
export const REQUEST_CAREER_FAILURE = 'REQUEST_CAREER_FAILURE';
export const REQUEST_CAREER_SUCCESS = 'REQUEST_CAREER_SUCCESS';

// Certificate
export const REQUEST_CERTIFICATE = 'REQUEST_CERTIFICATE';
export const REQUEST_CERTIFICATE_FAILURE = 'REQUEST_CERTIFICATE_FAILURE';
export const REQUEST_CERTIFICATE_SUCCESS = 'REQUEST_CERTIFICATE_SUCCESS';

// Dialog Box
export const HIDE_DIALOG_BOX = 'HIDE_DIALOG_BOX';
export const SHOW_DIALOG_BOX = 'SHOW_DIALOG_BOX';

// Education
export const REQUEST_EDUCATION = 'REQUEST_EDUCATION';
export const REQUEST_EDUCATION_FAILURE = 'REQUEST_EDUCATION_FAILURE';
export const REQUEST_EDUCATION_SUCCESS = 'REQUEST_EDUCATION_SUCCESS';

// Login
export const INITIALIZE_LOGIN = 'INITIALIZE_LOGIN';
export const LOGIN = 'LOGIN';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_STEP = 'LOGIN_STEP';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_VALIDATION_ERRORS = 'LOGIN_VALIDATION_ERRORS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const NOT_AUTHENTICATED = 'NOT_AUTHENTICATED';
export const AUTHENTICATED = 'AUTHENTICATED';
export const SSO_CHECK_START = 'SSO_CHECK_START';
export const SSO_CHECK_END = 'SSO_CHECK_END';
export const SET_SECURITY_CODE = 'SET_SECURITY_CODE';

export const SET_DETAIL_IDS = 'SET_DETAIL_IDS';

// Appraisal
export const REQUEST_APPRAISAL = 'REQUEST_APPRAISAL';
export const REQUEST_APPRAISAL_SUCCESS = 'REQUEST_APPRAISAL_SUCCESS';
export const REQUEST_APPRAISAL_FAILURE = 'REQUEST_APPRAISAL_FAILURE';
export const REQUEST_APPRAISAL_BY_ID = 'REQUEST_APPRAISAL_BY_ID';
export const REQUEST_APPRAISAL_BY_ID_SUCCESS = 'REQUEST_APPRAISAL_BY_ID_SUCCESS';
export const REQUEST_APPRAISAL_BY_ID_FAILURE = 'REQUEST_APPRAISAL_BY_ID_FAILURE';
export const RESET_APPRAISAL_LOADING = 'RESET_APPRAISAL_LOADING';
export const SAVING_APPRAISAL = 'SAVING_APPRAISAL';
export const SAVING_APPRAISAL_SUCCESS = 'SAVING_APPRAISAL_SUCCESS';
export const SAVING_APPRAISAL_FAILURE = 'SAVING_APPRAISAL_FAILURE';
export const SUBMIT_APPRAISAL = 'SUBMIT_APPRAISAL';
export const SUBMIT_APPRAISAL_SUCCESS = 'SUBMIT_APPRAISAL_SUCCESS';
export const SUBMIT_APPRAISAL_FAILURE = 'SUBMIT_APPRAISAL_FAILURE';
export const SET_FINAL_ANSWERS = 'SET_FINAL_ANSWER';
export const SET_MANAGER_ANSWERS = 'SET_MANAGER_ANSWER';
export const SET_EMPLOYEE_ANSWERS = 'SET_EMPLOYEE_ANSWER';
export const SET_MANAGER_YEAR = 'SET_MANAGER_YEAR';
export const SET_EMPLOYEE_YEAR = 'SET_EMPLOYEE_YEAR';
export const SET_APPRAISAL_TAB = 'SET_APPRAISAL_TAB';

// Manager Appraisal
export const REQUEST_MANAGER_APPRAISAL = 'REQUEST_MANAGER_APPRAISAL';
export const REQUEST_MANAGER_APPRAISAL_SUCCESS = 'REQUEST_MANAGER_APPRAISAL_SUCCESS';
export const REQUEST_MANAGER_APPRAISAL_FAILURE = 'REQUEST_MANAGER_APPRAISAL_FAILURE';
export const SET_EMPLOYEE = 'SET_EMPLOYEE';

//  Emoployee Holiday
export const REQUEST_HOLIDAY = 'REQUEST_HOLIDAY';
export const REQUEST_HOLIDAY_SUCCESS = 'REQUEST_HOLIDAY_SUCCESS';
export const REQUEST_HOLIDAY_FAILURE = 'REQUEST_HOLIDAY_FAILURE';
export const REQUEST_HOLIDAY_OVERVIEW = 'REQUEST_HOLIDAY_OVERVIEW';
export const REQUEST_HOLIDAY_OVERVIEW_SUCCESS = 'REQUEST_HOLIDAY_OVERVIEW_SUCCESS';
export const REQUEST_HOLIDAY_OVERVIEW_FAILURE = 'REQUEST_HOLIDAY_OVERVIEW_FAILURE';
export const SET_HOLIDAY_INFO = 'SET_HOLIDAY_INFO';
export const FETCH_HOLIDAY_BY_YEAR = 'FETCH_HOLIDAY_BY_YEAR';
export const FETCH_HOLIDAY_BY_YEAR_SUCCESS = 'FETCH_HOLIDAY_BY_YEAR_SUCCESS';
export const FETCH_HOLIDAY_BY_YEAR_FAILURE = 'FETCH_HOLIDAY_BY_YEAR_FAILURE';

//  Emoployee Bank
export const REQUEST_BANK = 'REQUEST_BANK';
export const REQUEST_BANK_SUCCESS = 'REQUEST_BANK_SUCCESS';
export const REQUEST_BANK_FAILURE = 'REQUEST_BANK_FAILURE';
export const SET_BANK_BRANCHES = 'SET_BANK_BRANCHES';
export const REQUEST_BANK_BRANCHES = 'REQUEST_BANK_BRANCHES';

export const SET_ACCOUNT_STATUS = 'SET_ACCOUNT_STATUS';
export const CREATE_NEW_ACCOUNT = 'CREATE_NEW_ACCOUNT';
export const CLEAR_NEW_ACCOUNT = 'CLEAR_NEW_ACCOUNT';

export const REQUEST_BANK_UPDATE = 'REQUEST_BANK_UPDATE';
export const REQUEST_BANK_UPDATE_SUCCESS = 'REQUEST_BANK_UPDATE_SUCCESS';
export const REQUEST_BANK_UPDATE_FAILURE = 'REQUEST_BANK_UPDATE_FAILURE';

// Profile
export const REQUEST_EMPLOYEE_MASTER = 'REQUEST_EMPLOYEE_MASTER';
export const REQUEST_EMPLOYEE_MASTER_FAILURE = 'REQUEST_EMPLOYEE_MASTER_FAILURE';
export const REQUEST_EMPLOYEE_MASTER_SUCCESS = 'REQUEST_EMPLOYEE_MASTER_SUCCESS';
export const REQUEST_EMPLOYEE_DETAIL_ORG = 'REQUEST_EMPLOYEE_DETAIL_ORG';
export const REQUEST_EMPLOYEE_DETAIL_ORG_FAILURE = 'REQUEST_EMPLOYEE_DETAIL_ORG_FAILURE';
export const REQUEST_EMPLOYEE_DETAIL_ORG_SUCCESS = 'REQUEST_EMPLOYEE_DETAIL_ORG_SUCCESS';
export const PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_REQUEST = 'PATCH_IDENTIFICATIONCARD_REQUEST';
export const PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_SUCCESS = 'PATCH_IDENTIFICATIONCARD_SUCCESS';
export const PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_FAILURE = 'PATCH_IDENTIFICATIONCARD_FAILURE';

// Qualification
export const REQUEST_QUALIFICATION = 'REQUEST_QUALIFICATION';
export const REQUEST_QUALIFICATION_FAILURE = 'REQUEST_QUALIFICATION_FAILURE';
export const REQUEST_QUALIFICATION_SUCCESS = 'REQUEST_QUALIFICATION_SUCCESS';

// Courses
export const REQUEST_EMPLOYEE_MASTER_COURSES = 'REQUEST_EMPLOYEE_MASTER_COURSES';
export const REQUEST_EMPLOYEE_MASTER_COURSES_FAILURE = 'REQUEST_EMPLOYEE_MASTER_COURSES_FAILURE';
export const REQUEST_EMPLOYEE_MASTER_COURSES_SUCCESS = 'REQUEST_EMPLOYEE_MASTER_COURSES_SUCCESS';
export const REQUEST_COURSES = 'REQUEST_COURSES';
export const REQUEST_COURSES_FAILURE = 'REQUEST_COURSES_FAILURE';
export const REQUEST_COURSES_SUCCESS = 'REQUEST_COURSES_SUCCESS';
export const REQUEST_COURSE_ATTENDANCE = 'REQUEST_COURSE_ATTENDANCE';
export const REQUEST_COURSE_ATTENDANCE_SUCCESS = 'REQUEST_COURSE_ATTENDANCE_SUCCESS';
export const REQUEST_COURSE_ATTENDANCE_FAILURE = 'REQUEST_COURSE_ATTENDANCE_FAILURE';
export const REQUEST_COURSE_LEAVE = 'REQUEST_COURSE_LEAVE';
export const REQUEST_COURSE_LEAVE_SUCCESS = 'REQUEST_COURSE_LEAVE_SUCCESS';
export const REQUEST_COURSE_LEAVE_FAILURE = 'REQUEST_COURSE_LEAVE_FAILURE';

export const COURSE_EVAL_LIST_REQUEST = 'COURSE_EVAL_LIST_REQUEST';
export const COURSE_EVAL_LIST_SUCCESS = 'COURSE_EVAL_LIST_SUCCESS';
export const COURSE_EVAL_LIST_FAILURE = 'COURSE_EVAL_LIST_FAILURE';

export const COURSE_EVAL_REQUEST = 'COURSE_EVAL_REQUEST';
export const COURSE_EVAL_SUCCESS = 'COURSE_EVAL_SUCCESS';
export const COURSE_EVAL_FAILURE = 'COURSE_EVAL_FAILURE';

export const COURSE_EVAL_SAVE_REQUEST = 'COURSE_EVAL_SAVE_REQUEST';
export const COURSE_EVAL_SAVE_SUCCESS = 'COURSE_EVAL_SAVE_SUCCESS';
export const COURSE_EVAL_SAVE_FAILURE = 'COURSE_EVAL_SAVE_FAILURE';

export const COURSE_EVAL_SUBMIT_REQUEST = 'COURSE_EVAL_SUBMIT_REQUEST';
export const COURSE_EVAL_SUBMIT_SUCCESS = 'COURSE_EVAL_SUBMIT_SUCCESS';
export const COURSE_EVAL_SUBMIT_FAILURE = 'COURSE_EVAL_SUBMIT_FAILURE';

// Course Questionnaire
export const COURSE_QUEST_REQUEST = 'COURSE_QUEST_REQUEST';
export const COURSE_QUEST_SUCCESS = 'COURSE_QUEST_SUCCESS';
export const COURSE_QUEST_FAILURE = 'COURSE_QUEST_FAILURE';

export const COURSE_QUEST_SUBMIT_REQUEST = 'COURSE_QUEST_SUBMIT_REQUEST';
export const COURSE_QUEST_SUBMIT_SUCCESS = 'COURSE_QUEST_SUBMIT_SUCCESS';
export const COURSE_QUEST_SUBMIT_FAILURE = 'COURSE_QUEST_SUBMIT_FAILURE';

// EmployeeSearch
export const SEARCH_REQUEST = 'SEARCH_REQUEST';
export const SEARCH_REQUEST_CLEAR = 'SEARCH_REQUEST_CLEAR';
export const SEARCH_REQUEST_SUCCESS = 'SEARCH_REQUEST_SUCCESS';
export const SEARCH_REQUEST_FAILURE = 'SEARCH_REQUEST_FAILURE';
export const SEARCH_REQUEST_SUCCESS_ALL = 'SEARCH_REQUEST_SUCCESS_ALL';

// Create new entitys in QData
export const CREATE_ENTITY_REQUEST = 'CREATE_ENTITY_REQUEST';
export const CREATE_ENTITY_REQUEST_SUCCESS = 'CREATE_ENTITY_REQUEST_SUCCESS';
export const CREATE_ENTITY_REQUEST_FAILURE = 'CREATE_ENTITY_REQUEST_FAILURE';

// Save entitys in QData
export const SAVE_ENTITY_REQUEST = 'SAVE_ENTITY_REQUEST';
export const SAVE_ENTITY_REQUEST_SUCCESS = 'SAVE_ENTITY_REQUEST_SUCCESS';
export const SAVE_ENTITY_REQUEST_FAILURE = 'SAVE_ENTITY_REQUEST_FAILURE';

// Delete entitys in QData
export const DELETE_ENTITY_REQUEST = 'DELETE_ENTITY_REQUEST';
export const DELETE_ENTITY_REQUEST_SUCCESS = 'DELETE_ENTITY_REQUEST_SUCCESS';
export const DELETE_ENTITY_REQUEST_FAILURE = 'DELETE_ENTITY_REQUEST_FAILURE';

// Settings
export const NEW_PASSWORD_REQUEST = 'NEW_PASSWORD_REQUEST';
export const NEW_PASSWORD_SUCCESS = 'NEW_PASSWORD_SUCCESS';
export const NEW_PASSWORD_FAILURE = 'NEW_PASSWORD_FAILURE';

// FILES

export const REQUEST_FILES = 'REQUEST_FILES';
export const REQUEST_FILES_SUCCESS = 'REQUEST_FILES_SUCCESS';
export const REQUEST_FILES_FAILURE = 'REQUEST_FILES_FAILURE';

export const REQUEST_PAYSLIPS = 'REQUEST_PAYSLIPS';
export const REQUEST_PAYSLIPS_SUCCESS = 'REQUEST_PAYSLIPS_SUCCESS';
export const REQUEST_PAYSLIPS_FAILURE = 'REQUEST_PAYSLIPS_FAILURE';

export const REQUEST_FILE_DOWNLOAD = 'REQUEST_FILE_DOWNLOAD';
export const REQUEST_FILE_DOWNLOAD_SUCCESS = 'REQUEST_FILE_DOWNLOAD_SUCCESS';
export const REQUEST_FILE_DOWNLOAD_FAILURE = 'REQUEST_FILE_DOWNLOAD_FAILURE';

export const REQUEST_FILE_DELETE = 'REQUEST_FILE_DELETE';
export const REQUEST_FILE_DELETE_SUCCESS = 'REQUEST_FILE_DELETE_SUCCESS';
export const REQUEST_FILE_DELETE_FAILURE = 'REQUEST_FILE_DELETE_FAILURE';

export const REQUEST_FILE_UPLOAD = 'REQUEST_FILE_UPLOAD';
export const REQUEST_FILE_UPLOAD_SUCCESS = 'REQUEST_FILE_UPLOAD_SUCCESS';
export const REQUEST_FILE_UPLOAD_FAILURE = 'REQUEST_FILE_UPLOAD_FAILURE';

export const INIT_FILE_UPLOAD = 'INIT_FILE_UPLOAD';
export const INIT_FILE_UPLOAD_SUCCESS = 'INIT_FILE_UPLOAD_SUCCESS';
export const INIT_FILE_UPLOAD_FAILURE = 'INIT_FILE_UPLOAD_FAILURE';

export const REQUEST_FILE_BY_ID = 'REQUEST_FILE_BY_ID';
export const REQUEST_FILE_BY_ID_SUCCESS = 'REQUEST_FILE_BY_ID_SUCCESS';
export const REQUEST_FILE_BY_ID_FAILURE = 'REQUEST_FILE_BY_ID_FAILURE';

// OrgChart
export const ORGCHART_REQUEST_DATA = 'ORGCHART_REQUEST_DATA';
export const ORGCHART_REQUEST_DATA_SUCCESS = 'ORGCHART_REQUEST_DATA_SUCCESS';
export const ORGCHART_REQUEST_DATA_FAILURE = 'ORGCHART_REQUEST_DATA_FAILURE';
export const ORGCHART_SET_ACTIVE_NODE = 'ORGCHART_SET_ACTIVE_NODE';

// WebValues

export const REQUEST_WEB_VALUES = 'REQUEST_WEB_VALUES';
export const REQUEST_WEB_VALUES_SUCCESS = 'REQUEST_WEB_VALUES_SUCCESS';
export const REQUEST_WEB_VALUES_FAILURE = 'REQUEST_WEB_VALUES_FAILURE';

export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_PAY_YEAR = 'SET_PAY_YEAR';
export const SET_GROUP_FILTER = 'SET_GROUP_FILTER';

export const REQUEST_TAX_CARDS = 'REQUEST_TAX_CARDS';
export const REQUEST_TAX_CARDS_SUCCESS = 'REQUEST_TAX_CARDS_SUCCESS';
export const REQUEST_TAX_CARDS_FAILURE = 'REQUEST_TAX_CARDS_FAILURE';

export const REQUEST_CREATE_TAX_CARDS = 'REQUEST_CREATE_TAX_CARDS';
export const REQUEST_CREATE_TAX_CARDS_SUCCESS = 'REQUEST_CREATE_TAX_CARDS_SUCCESS';
export const REQUEST_CREATE_TAX_CARDS_FAILURE = 'REQUEST_CREATE_TAX_CARDS_FAILURE';
export const REQUEST_UPDATE_TAX_CARD = 'REQUEST_UPDATE_TAX_CARD';
export const REQUEST_UPDATE_TAX_CARD_SUCCESS = 'REQUEST_UPDATE_TAX_CARD_SUCCESS';
export const REQUEST_UPDATE_TAX_CARD_FAILURE = 'REQUEST_UPDATE_TAX_CARD_FAILURE';
export const SET_TAX_CARD_INFO = 'SET_TAX_CARD_INFO';
export const SET_TAX_CARD_STATUS = 'SET_TAX_CARD_STATUS';
export const SET_TAX_DISCOUNT = 'SET_TAX_DISCOUNT';

export const REQUEST_AGREEMENTS = 'REQUEST_AGREEMENTS';
export const REQUEST_AGREEMENTS_SUCCESS = 'REQUEST_AGREEMENTS_SUCCESS';
export const REQUEST_AGREEMENTS_FAILURE = 'REQUEST_AGREEMENTS_FAILURE';

export const REQUEST_AGREEMENT_YES = 'REQUEST_AGREEMENT_YES';
export const REQUEST_AGREEMENT_NO = 'REQUEST_AGREEMENT_NO';

export const UPDATE_AGREEMENT_ANSWERS = 'UPDATE_AGREEMENT_ANSWERS';

// Birthdays
export const REQUEST_BIRTHDAYS = 'REQUEST_BIRTHDAYS';
export const REQUEST_BIRTHDAYS_SUCCESS = 'REQUEST_BIRTHDAYS_SUCCESS';
export const REQUEST_BIRTHDAYS_FAILURE = 'REQUEST_BIRTHDAYS_FAILURE';

// Benefits
export const REQUEST_BENEFITS = 'REQUEST_BENEFITS';
export const REQUEST_BENEFITS_SUCCESS = 'REQUEST_BENEFITS_SUCCESS';
export const REQUEST_BENEFITS_FAILURE = 'REQUEST_BENEFITS_FAILURE';

export const FITNESS_GRANT_REGISTER_REQUEST = 'FITNESS_GRANT_REGISTER_REQUEST';
export const FITNESS_GRANT_REGISTER_SUCCESS = 'FITNESS_GRANT_REGISTER_SUCCESS';
export const FITNESS_GRANT_REGISTER_FAILURE = 'FITNESS_GRANT_REGISTER_FAILURE';

export const GRANT_REGISTER_REQUEST = 'GRANT_REGISTER_REQUEST';
export const GRANT_REGISTER_SUCCESS = 'GRANT_REGISTER_SUCCESS';
export const GRANT_REGISTER_FAILURE = 'GRANT_REGISTER_FAILURE';

// Email
export const SEND_EMAIL = 'SEND_EMAIL';
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS';
export const SEND_EMAIL_FAILURE = 'SEND_EMAIL_FAILURE';

// Loans
export const REQUEST_LOANS = 'REQUEST_LOANS';
export const REQUEST_LOANS_FAILURE = 'REQUEST_LOANS_FAILURE';
export const REQUEST_LOANS_SUCCESS = 'REQUEST_LOANS_SUCCESS';

// Union
export const REQUEST_UNION = 'REQUEST_UNION';
export const REQUEST_UNION_FAILURE = 'REQUEST_UNION_FAILURE';
export const REQUEST_UNION_SUCCESS = 'REQUEST_UNION_SUCCESS';

// Union
export const REQUEST_EMPLOYEE_UNION = 'REQUEST_EMPLOYEE_UNION';
export const REQUEST_EMPLOYEE_UNION_FAILURE = 'REQUEST_EMPLOYEE_UNION_FAILURE';
export const REQUEST_EMPLOYEE_UNION_SUCCESS = 'REQUEST_EMPLOYEE_UNION_SUCCESS';

// Pension
export const REQUEST_PENSION = 'REQUEST_PENSION';
export const REQUEST_PENSION_FAILURE = 'REQUEST_PENSION_FAILURE';
export const REQUEST_PENSION_SUCCESS = 'REQUEST_PENSION_SUCCESS';

// ApprovalRequests
export const APPROVAL_REQUEST_CREATE = 'APPROVAL_REQUEST_CREATE';
export const APPROVAL_REQUEST_SUCCESS = 'APPROVAL_REQUEST_SUCCESS';
export const APPROVAL_REQUEST_FAILURE = 'APPROVAL_REQUEST_FAILURE';

// Bonuses
export const REQUEST_BONUSES = 'REQUEST_BONUSES';
export const REQUEST_BONUSES_SUCCESS = 'REQUEST_BONUSES_SUCCESS';
export const REQUEST_BONUSES_FAILURE = 'REQUEST_BONUSES_FAILURE';

// PerDiem
export const PerDiemAmountTypeEnum = [
  'Accommodation', // Gisting 1
  'Other', // Annað 2
  'Total', // Samtals 3
];

export const PERDIEM_INIT_APPROVAL_REQUEST = 'PERDIEM_INIT_APPROVAL_REQUEST';
export const PERDIEM_INIT_APPROVAL_SUCCESS = 'PERDIEM_INIT_APPROVAL_SUCCESS';
export const PERDIEM_INIT_APPROVAL_FAILURE = 'PERDIEM_INIT_APPROVAL_FAILURE';

export const PERDIEM_CALCULATE_REQUEST = 'PERDIEM_CALCULATE_REQUEST';
export const PERDIEM_CALCULATE_SUCCESS = 'PERDIEM_CALCULATE_SUCCESS';
export const PERDIEM_CALCULATE_FAILURE = 'PERDIEM_CALCULATE_FAILURE';
export const PERDIEM_CALCULATE_RESET = 'PERDIEM_CALCULATE_RESET';

export const PERDIEM_APPROVAL_REQUEST = 'PERDIEM_APPROVAL_REQUEST';
export const PERDIEM_APPROVAL_SUCCESS = 'PERDIEM_APPROVAL_SUCCESS';
export const PERDIEM_APPROVAL_FAILURE = 'PERDIEM_APPROVAL_FAILURE';

export const PERDIEM_RECORDS_APPEND = 'PERDIEM_RECORDS_APPEND';

export const CALCULATE_REQUEST = 'PERDIEM_CALCULATE_REQUEST';
export const CALCULATE_SUCCESS = 'PERDIEM_CALCULATE_SUCCESS';
export const CALCULATE_FAILURE = 'PERDIEM_CALCULATE_FAILURE';
export const CALCULATE_RESET = 'PERDIEM_CALCULATE_RESET';



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js